import { isDefined } from "@clipboard-health/util-ts";
import { formatDollarsAsUsd } from "@src/appV2/lib/Money/utils/currency";

import {
  MANDATORY_BREAK_DURATION_IN_MINUTES,
  MINIMUM_TIME_FOR_MANDATORY_BREAK_IN_HOURS,
} from "./constants";
import { type ModalShiftAuctionData, type ShiftFormattedPayBreakdown } from "./types";

// eslint-disable-next-line max-params
export function getFormattedShiftPayBreakdown(
  offerPay?: number,
  finalPay?: number,
  originalAmount?: number | null,
  shiftBoost?: number,
  shiftLengthInHours?: number,
  requiresLunchBreak?: boolean
): ShiftFormattedPayBreakdown | undefined {
  const hourlyPayValue = offerPay ?? finalPay;

  if (!isDefined(hourlyPayValue)) {
    return undefined;
  }

  if (!isDefined(originalAmount)) {
    return undefined;
  }

  const canSkipBreak =
    isDefined(shiftLengthInHours) &&
    shiftLengthInHours >= MINIMUM_TIME_FOR_MANDATORY_BREAK_IN_HOURS &&
    requiresLunchBreak === false;

  const workedBreakPayment = (hourlyPayValue * MANDATORY_BREAK_DURATION_IN_MINUTES) / 60;
  const workedBreakPay = {
    totalPay: formatDollarsAsUsd(originalAmount + workedBreakPayment),
    ...(isDefined(shiftBoost) && {
      totalWithBoostPay: formatDollarsAsUsd(originalAmount + shiftBoost + workedBreakPayment),
    }),
  };

  return {
    totalPay: formatDollarsAsUsd(originalAmount),
    hourlyPay: formatDollarsAsUsd(hourlyPayValue),
    ...(isDefined(shiftBoost) && {
      totalWithBoostPay: formatDollarsAsUsd(originalAmount + shiftBoost),
    }),
    ...(canSkipBreak && { workedBreakPay }),
  };
}

export function getFormattedShiftPayBreakdownWithShiftAuction(
  shiftAuction: Pick<ModalShiftAuctionData["attributes"], "minimumPay" | "maximumPay">
): ShiftFormattedPayBreakdown | undefined {
  const minimumPay = shiftAuction.minimumPay.amountInMinorUnits / 100;
  const maximumPay = shiftAuction.maximumPay.amountInMinorUnits / 100;

  return {
    totalPay: "Bid to Win",
    hourlyPay: `${formatDollarsAsUsd(minimumPay)} - ${formatDollarsAsUsd(maximumPay)}`,
  };
}
